import React, { useState, useEffect } from 'react';
import { MDBBadge, MDBTable, MDBTooltip } from 'mdb-react-ui-kit';
// import FlipMove from "react-flip-move"
import TableHeader from '../../../components/table/TableHeader';
import TableBody from '../../../components/table/TableBody';
import './ClasificacionPage.scss';


export default function ClasificacionPage({torneoEnCurso,...props}) {
  const [torneo, setTorneo] = useState(torneoEnCurso);

  const [hiddeColumns, setHiddeColumns] = useState();
  const [hiddeColumnsBool, setHiddeColumnsBool] = useState(false);

  useEffect(() => {
    setHiddeColumns(window.innerWidth < 882 ? 'none':'table-cell');
    setHiddeColumnsBool(hiddeColumns === 'none');
  });
  
  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  useEffect(() => {
    setTorneo(torneoEnCurso);
  },[torneoEnCurso]);

  const getWinnerIndex = (roundNumMatchResult) => {
    let winnerIndex = -1;
    let winnerPoints = 0;
    roundNumMatchResult.points.map((item, index) => {
      if (item > winnerPoints) {
        winnerPoints = item;
        winnerIndex = index;
      }
    })

    return winnerIndex;
  }

  const getOpponentIndexs = (doublet_id, roundNumMatchResult) => {
    let opponents = [];
    if (roundNumMatchResult.ids.length > 1) {
      roundNumMatchResult.ids.map((id, index) => {
        if (id !== doublet_id) {
          torneo.doublets.map((doublet, i) => {
            if (id === doublet.id ) {
              opponents.push({id: doublet.id, nameDoublet: doublet.nameDoublet});
            }
          }) 
        }
      })
    }

    return opponents;
  }

  const getMatchWhereIsPlayer = (doublet_id, roundNumMatchResult) => {
    let matchIndex = -1;
    roundNumMatchResult.ids.map((id, index) => {
      if (id === doublet_id) {
        matchIndex = index;
      }
    })

    return matchIndex;
  }

  const isPlayerOnMatch = (doublet_id, roundNumMatchResult ) => {
    let find = false;
    roundNumMatchResult.ids.map((id, index) => {
      if (id === doublet_id) {
        find = true;
      }
    })

    return find;
  }

  const getResultClass = (doublet_id, roundNumMatchResult ) => {
    if (roundNumMatchResult.ids) {
      if (roundNumMatchResult.ids.length > 1) {
        let winnerIndex = getWinnerIndex(roundNumMatchResult);
        if (winnerIndex !== -1) {
          if (roundNumMatchResult.ids[winnerIndex] === doublet_id) {
            return 'win'
          } else {
            return 'lost'
          }
        }
      } else {
        return 'exent'
      }
    }
    return 'eliminate'
  }

  // let puesto = 1;
  return (
    torneo && torneo.doublets ? <>
      <div className="pt-3" style={{maxWidth:'100vw'}}>
        <div style={{overflow: 'auto', position: 'relative'}}>
          {/* <MDBRow>
          </MDBRow> */}
          <MDBTable striped align='middle'>
            <TableHeader light>
              <tr>
                <th colSpan={3} className='text-center sticky-col-row1' style={{zIndex:'99'}}>Listado Parejas</th>
                <th colSpan={1} className='text-center'>Puesto</th>
                <th colSpan={3} className='text-center'>Partidas</th>
                <th colSpan={2} style={{display: hiddeColumns}} className='text-center'>Juegos</th>
                <th colSpan={torneo.roundResults && torneo.roundResults.length > 0 ? torneo.roundResults.length : 0} className='text-center'>Rondas</th>
              </tr>
              <tr>
                <th style={{width:'20px', zIndex:'99'}} className='sticky-col1-row2'>Num</th>
                <th style={{width: (hiddeColumnsBool?'145px':'250px'), minWidth: (hiddeColumnsBool?'145px':'250px'), maxWidth: (hiddeColumnsBool?'145px':'250px'), zIndex:'99'}} className='sticky-col2-row2'>Pareja</th>
                <th style={{width:'100px', zIndex:'99'}} className='text-center sticky-col3-row2'>Estado</th>
                <th style={{minWidth:'70px', maxWidth:'130px'}}>Puesto</th>
                <th style={{width:'30px', display: hiddeColumns}} className='text-center'>G</th>
                <th style={{width:'30px', display: hiddeColumns}} className='text-center'>P</th>
                <th style={{width:'30px'}} className='text-center'>E</th>
                <th style={{width:'30px'}} className='text-center'>F</th>
                <th style={{width:'30px'}} className='text-center'>C</th>
                {torneo.roundResults && torneo.roundResults.length > 0 && torneo.roundResults?.map((result, index) => {
                  return (
                    <th style={{minWidth:'90px'}} className='text-center'>
                      {'Ronda' + (index + 1)}
                    </th>
                  )
                })}
              </tr>
            </TableHeader>
            <TableBody>
              {/* <FlipMove duration={750} easing="ease-out"> */}
                {torneo.doublets?.sort((a, b) => {
                  // let result = ((b.earned + b.exents) * torneo.numJuegos) - ((a.earned + a.exents) * torneo.numJuegos);
                  // if (result === 0) {
                  //   result = ((a.losses) * torneo.numJuegos) - ((b.losses) * torneo.numJuegos);
                  // }
                  let result = a.position - b.position;
                  return result;
                }).map((item, index) => {
                  return (
                    <tr>
                      <td className='sticky-col1-row2' style={{zIndex:'99'}} >
                        {item.id}
                      </td>
                      <td className='sticky-col2-row2' style={{width: (hiddeColumnsBool?'145px':'250px'), minWidth: (hiddeColumnsBool?'145px':'250px'), maxWidth: (hiddeColumnsBool?'145px':'250px'), textWrap: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', zIndex:'99'}}>
                        {item.nameDoublet}
                      </td>
                      <td  className='sticky-col3-row2 text-center' style={{zIndex:'99'}} >
                        <MDBBadge color={item.status === 'Continua' ? 'success' : 'danger'} pill>
                          {item.status}
                        </MDBBadge>
                      </td>
                      <td className='text-center'>{item.position ? item.position : 1}</td>
                      <td style={{color: '#4baf4f', fontWeight: 'bold'}} className='text-center'>{item.earned}</td>
                      <td style={{color: 'red', fontWeight: 'bold'}} className='text-center'>{item.losses}</td>
                      <td style={{color: '#3883fe', fontWeight: 'bold'}} className='text-center'>{item.exents}</td>
                      {/* <td className='text-center'>{(item.earned + item.exents) * torneo.numJuegos}</td> */}
                      {/* <td className='text-center'>{item.losses * torneo.numJuegos}</td> */}
                      <td style={{display: hiddeColumns}} className='text-center'>{item.pointsPositive}</td>
                      <td style={{display: hiddeColumns}} className='text-center'>{item.pointsNegative}</td>
                      {torneo.roundResults && torneo.roundResults.length > 0 && torneo.roundResults?.map((roundNumResult, roundNumIndex) => {
                        return roundNumResult?.map((roundNumMatchResult, roundNumMatchResultIndex) => {
                          if (roundNumIndex < torneo.roundNum && isPlayerOnMatch(item.id, roundNumMatchResult)) {
                            if (roundNumIndex > item.elminateOnRound && item.status !== 'Continua') {
                              // return <td className={'text-center  eliminate'}>Eliminado</td>
                              return <td></td>
                            } else {
                              const match = getMatchWhereIsPlayer(item.id, roundNumMatchResult);
                              const winner = getWinnerIndex(roundNumMatchResult);
                              const opponents = getOpponentIndexs(item.id, roundNumMatchResult);
                            
                              if (match === -1 || winner === -1) {
                                // if (winner === 1 && item.status === "Eliminado") {
                                //   return <td className={'text-center  eliminate'}>Eliminado</td>
                                // } else {
                                  return ''
                                // }
                              } else {
                                if (opponents.length === 0) {
                                  return <td className={'text-center  exent'}>Exento</td>
                                } else if (opponents.length > 0) {
                                  return (
                                    // <td className='text-center' style={{background: '' + getBackground(item.nameDoublet, roundNumMatchResult), color: 'white'}}>
                                    <td className={'text-center  ' + getResultClass(item.id, roundNumMatchResult)}>
                                      {/* { (match === winner ? 'G' : 'P') + 
                                      ' (Vs-' +
                                      opponents.map((opponent) => {
                                        return opponent
                                      }) +
                                      ')'} */}
                                      <MDBTooltip tag='span' title={opponents.map((opponent) => {return opponent.nameDoublet})}>                                    
                                      { (match === winner ? 'G' : 'P') + 
                                      ' (Vs-' +
                                      opponents.map((opponent) => {
                                        return opponent.id
                                      }) +
                                      ')'}</MDBTooltip >
                                    </td>
                                  )
                                }
                              }
                            }
                          }
                        })
                      })}
                    </tr>
                  )
                })}
              {/* </FlipMove> */}
            </TableBody>
          </MDBTable>
        </div>
      </div>
    </> : <div>"PENDING SAVE MATCH GENERATED BY ELIMINATORY PROPERLY ON DEFINED STRUCTURE"</div>
  );
}
